import { Box } from "@mui/material";
import FilterMenu from "../../../../components/filters/FilterMenu";
import TimeFilter from "../../../../components/filters/TimeFilter";
import SvgToIcon from "../../../../icons/SvgToIcon";
import { Platforms, ServerOS } from "../../../../utils/constants";
import {
  getMacOSName,
  getWindowsOSName,
} from "../components/entitiesCharts/hostChart/osVersionDistribution/osVersionHelpers";
import { icons } from "../icons/iconExport";
import { platformIcons } from "../utils";
import { pastTimeOptions } from "./EntityTypeRegularFilters";
import { cveOptions } from "./sharedFilters";
import { ALL_OPTION_NAME, filterName } from "./utils";

const getHostOSOptions = (fetchedEntities) => {
  const osList = new Set(
    fetchedEntities.map((entity) => entity.platform).filter(Boolean)
  );

  // Check if any Windows hosts have server_os field set to Windows Server
  const hasWindowsServer = fetchedEntities.some(
    (entity) => entity.server_os === ServerOS.WINDOWS_SERVER
  );

  // Add Windows Server to the list if it exists
  if (hasWindowsServer) {
    osList.add(ServerOS.WINDOWS_SERVER);
  }

  return [
    {
      name: ALL_OPTION_NAME,
      label: "All operating systems",
      displayName: "All",
    },
    ...Array.from(osList).map((hostOS) => ({
      name: hostOS,
      label: (
        <Box display="flex" gap={1} alignItems="center">
          <SvgToIcon
            IconLogo={platformIcons[hostOS] || icons.osVersionIcon}
            width={"16px"}
          />
          {hostOS}
        </Box>
      ),
      displayName: hostOS,
    })),
  ];
};
const getHostOSVersionOptions = (fetchedEntities, appliedFilters) => {
  const checkedOs = Object.entries(appliedFilters?.[filterName.HOST_OS] || {})
    .filter(([_, checked]) => checked)
    .map(([filterName, _]) => filterName);

  const osVersionList = new Set(
    fetchedEntities
      .filter(
        (entity) =>
          entity.os_version &&
          (Object.keys(checkedOs).length === 0 ||
            checkedOs.includes(ALL_OPTION_NAME) ||
            checkedOs.includes(entity.platform))
      )
      .map((entity) =>
        entity.platform === Platforms.WINDOWS
          ? getWindowsOSName(entity.os_version)
          : Platforms.MACOS === entity.platform
          ? getMacOSName(entity.os_version)
          : entity.os_version
      )
  );

  return [
    {
      name: ALL_OPTION_NAME,
      label: "All versions",
      displayName: "All",
    },
    ...Array.from(osVersionList)
      .sort()
      .reverse()
      .map((hostVersion) => ({
        name: hostVersion,
        label: (
          <Box display="flex" gap={1} alignItems="center">
            {hostVersion}
          </Box>
        ),
        displayName: hostVersion,
      })),
  ];
};
const getHostOSFullVersionOptions = (fetchedEntities, appliedFilters) => {
  const checkedOs = Object.entries(appliedFilters?.[filterName.HOST_OS] || {})
    .filter(([_, checked]) => checked)
    .map(([filterName, _]) => filterName);

  const osVersionList = new Set(
    fetchedEntities
      .filter(
        (entity) =>
          entity.os_version &&
          (Object.keys(checkedOs).length === 0 ||
            checkedOs.includes(ALL_OPTION_NAME) ||
            checkedOs.includes(entity.platform))
      )
      .map((entity) => entity.os_version)
  );

  return [
    {
      name: ALL_OPTION_NAME,
      label: "All versions",
      displayName: "All",
    },
    ...Array.from(osVersionList)
      .sort()
      .reverse()
      .map((hostVersion) => ({
        name: hostVersion,
        label: (
          <Box display="flex" gap={1} alignItems="center">
            {hostVersion}
          </Box>
        ),
        displayName: hostVersion,
      })),
  ];
};
export const getHostFilters = (params) => [
  <FilterMenu
    filterName={"OS"}
    fieldName={filterName.HOST_OS}
    options={getHostOSOptions(params.fetchedEntities)}
    appliedFilters={params.appliedFilters}
    setAppliedFilters={params.setAppliedFilters}
  />,
  <FilterMenu
    filterName={"OS Version"}
    fieldName={filterName.HOST_OS_VERSION}
    options={getHostOSVersionOptions(
      params.fetchedEntities,
      params.appliedFilters
    )}
    appliedFilters={params.appliedFilters}
    setAppliedFilters={params.setAppliedFilters}
  />,
  <FilterMenu
    filterName={"OS Build"}
    fieldName={filterName.HOST_OS_FULL_VERSION}
    options={getHostOSFullVersionOptions(
      params.fetchedEntities,
      params.appliedFilters
    )}
    appliedFilters={params.appliedFilters}
    setAppliedFilters={params.setAppliedFilters}
  />,
  <TimeFilter
    filterName={"Last Seen"}
    fieldName={filterName.HOST_LAST_SEEN}
    options={pastTimeOptions}
    appliedFilters={params.appliedFilters}
    setAppliedFilters={params.setAppliedFilters}
    filterLogic={params.filterAndOrLogics[filterName.HOST_LAST_SEEN]}
    setFilterLogic={params.setFilterAndOrLogics}
  />,
  <FilterMenu
    filterName={"CVE"}
    fieldName={filterName.CVE}
    options={cveOptions}
    appliedFilters={params.appliedFilters}
    setAppliedFilters={params.setAppliedFilters}
  />,
  <FilterMenu
    filterName={"Has Local Admin User"}
    fieldName={filterName.HAS_LOCAL_ADMIN_USER}
    options={[
      { name: "true", label: "Yes", displayName: "Yes" },
      { name: "false", label: "No", displayName: "No" },
    ]}
    appliedFilters={params.appliedFilters}
    setAppliedFilters={params.setAppliedFilters}
  />,
];
